<template>
  <div class="datepicker-container fill">
    <vue-datepicker :time.sync="time" :type="type" :option="option" :limit="limit" :locale="locale" :minute-label="minuteLabel" :hour-label="hourLabel"></vue-datepicker>
    <slot></slot>
  </div>
</template>

<script>
var label = require('vue').filter('label')
var lookup = require('vue').filter('lookup')
var local = require('common/store/local')
var moment = require('moment-timezone')
// var lang = local.get('client.language')
moment.tz.setDefault('UTC')
module.exports = {
  components: {
    vueDatepicker: require('c/components/vue-datepicker/vue-datepicker.vue')
  },
  props: [ 'time', 'type', 'format', 'limit', 'out' ],
  methods: {
    translate: function (lkp) {
      return lookup(lkp).map(function (lbl) {
        return label(lbl.label)
      })
    }
  },
  events: {
    out: function (d) {
      this.out = moment(d)
    }
  },
  computed: {
    option: function () {
      return {
        type: this.type,
        week: this.translate('DAY'),
        month: this.translate('MONTH'),
        format: this.format,
        placeholder: '',
        buttons: {
          ok: label('general.button.ok'),
          cancel: label('general.button.cancel')
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
        inputStyle: this.style
      }
    },
    locale: function () {
      var l = local.get('client.language')
      return l
    }
  },
  data: function () {
    return {
      style: {
        'display': 'inline-block',
        'width': '100%',
        'margin-top': '6px',
        'padding': '4px 0',
        'line-height': '18px',
        'font-size': '16px',
        'font-family': '"Helvetica","Arial",sans-serif',
        'border': 'none',
        'border-bottom': '1px solid rgba(0,0,0,.12)',
        'color': '#5F5F5F',
        'background': 'none'
      },
      minuteLabel: label('general.time.minute'),
      hourLabel: label('general.time.hour')
    }
  }
}
</script>

<style scoped>
  .datepicker-container {
    height: 40px;
  }
  .cov-vue-date {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// Datepicker.vue?a64c9d4a